module.exports = __webpack_public_path__ + "img/trunk.be5030ca.webp";